module.exports = __webpack_public_path__ + "static/img/prism_loader.cd8a9eb.gif";


//////////////////
// WEBPACK FOOTER
// ./static/prism/images/prism_loader.gif
// module id = ghtn
// module chunks = 76